import {extract} from './utils/openapi-extractor';
import {clone, merge} from 'lodash';

const SUPPORTED_EDITOR_ROLES = ['Administrator', 'Author', 'Editor'];

// Pure reducer extracted from openapi-context.js so it can be
// unit-tested without React. Handles spec lifecycle (setSpec /
// activate / terminate), editor-state side fields (current index
// for request body / response), role gating, and validation errors.
//
// `setSpec` keeps the raw spec by reference (no deep-clone) so the
// schema-block sample generator can resolve local
// #/components/schemas/* $refs against the full OpenAPI doc.
export function reducer(state, action, {backend} = {}) {
    switch (action.type) {
        case 'setSpec':
            // Previously reset `editMode: false` on every setSpec. That
            // looked harmless until library.js's auto-save round-trip
            // started firing setSpec on every commit (via the
            // backend.event$ subscribe → loadSpec → setSpec chain). The
            // reset kicked the user out of edit mode mid-edit, causing
            // the description Markdown panel to bounce between MDXEditor
            // (edit) and rendered HTML (view) — visible as the
            // "continuous flicker" reported on rename + pencil flows.
            //
            // editMode is now decoupled from spec replacement. If a
            // caller needs to drop edit mode (e.g., on hard navigation
            // to a different spec), they should dispatch 'terminate'
            // alongside 'setSpec'.
            return {
                ...state,
                key: action.key,
                rawSpec: action.spec,
                ...extract(action.spec, {backend}),
            };
        case 'activate':
            if (SUPPORTED_EDITOR_ROLES.indexOf(state.role) !== -1) {
                return clone(merge(state, {editMode: true, message: action.message}));
            } else {
                return state;
            }
        case 'terminate':
            return clone(merge(state, {editMode: false}));
        case 'setCurrentIndexRequestBody':
            return clone(merge(state, {currentIndexRequestBody: action.index}));
        case 'setCurrentIndexResponse':
            return {...state, currentIndexResponse: action.index};
        case 'change-role':
            return clone(merge(state, {role: action.role, accessToken: action.accessToken}));
        case 'validate-spec-error':
            return clone(merge(state, {specValidationErrors: action.errors}));
        case 'add-parameter-definition':
            state.addComponent('parameters', action.definition);
            return clone(state);
        default:
            throw new Error('invalid action');
    }
}

export {SUPPORTED_EDITOR_ROLES};
